import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { RemoveFromCartTrackingInfo } from "@omni/types/components/tracking/tracking-info/feature/removeFromCart.trackingInfo";

import { CartItemModel } from "@/redux/modules/api/data/cart/@types/cart.model";
import * as CartItemMapper from "@/services/tracking/mappers/cartItem.mapper";
import * as ProductMapper from "@/services/tracking/mappers/product.mapper";
import * as ProductTileProductMapper from "@/services/tracking/mappers/productTileProduct.mapper";
import { getPageInfo, getUserInfo } from "@/services/tracking/trackers/utils";
import * as TrackingService from "@/services/tracking/tracking.service";
import { TypedAnalyticsEvent } from "@/services/tracking/types/analyticsEvent";

export const track = (trackingInfo: RemoveFromCartTrackingInfo) => {
    const event: TypedAnalyticsEvent<RemoveFromCartTrackingInfo> = {
        event: EventType.RemoveFromCart,
        payload: {
            eventData: trackingInfo,
            pageInfo: getPageInfo(),
            userInfo: getUserInfo()
        }
    };

    TrackingService.track(event);
};

export const trackCartItem = (cartItem: CartItemModel, quantity: number) => {
    const trackingInfo = CartItemMapper.toRemoveFromCartTrackingInfo({
        item: cartItem,
        quantity
    });

    track(trackingInfo);
};

export const trackProductTileProduct = (
    product: Product<ProductFieldSet.ProductTile>,
    quantity: number
) => {
    const trackingInfo = ProductTileProductMapper.toRemoveFromCartTrackingInfo({
        product,
        quantity
    });

    track(trackingInfo);
};

export const trackECommerceProduct = (
    product: Product<ProductFieldSet.Full>,
    quantity: number
) => {
    const trackingInfo = ProductMapper.toRemoveFromCartTrackingInfo({
        product,
        quantity
    });

    track(trackingInfo);
};
